import React, { useRef } from 'react'
import '../styles/audiogrid.scss'


export default function AudioGrid({setFlicker}) {
  const ref1 = useRef()
  const ref2 = useRef()
  const ref3 = useRef()
  const ref4 = useRef()
  const ref5 = useRef()
  const ref6 = useRef()


  const clickDown = (e, ref) => {

    ref.current.currentTime = 0
    ref.current.volume = 1
    ref.current.play()


    setFlicker(true)
  } 


  const clickUp = (e, ref) => {


    ref.current.volume = 1
    setFlicker(false)

    let vol4ios = 1

    ref.current.pause()

    ref1.current.pause()
    ref2.current.pause()
    ref3.current.pause()
    ref4.current.pause()
    ref5.current.pause()
    ref6.current.pause()
  }



  return (
    <div className="audiogrid" >

      <div className="gridcell"
        onPointerDown={(e)=>clickDown(e, ref1)}
        onMouseDown={(e)=>clickDown(e, ref1)}
        onPointerUp={(e)=>clickUp(e, ref1)}
        onMouseUp={(e)=>clickUp(e, ref1)}
        onTouchEnd={(e)=>clickUp(e, ref1)}
        onPointerOut={(e)=>clickUp(e, ref1)}
        >
        <audio ref={ref1} loop >
          <source  src="/audio/clip1.mp3" type="audio/mpeg" />
        </audio>
      </div>

      <div className="gridcell"
        onPointerDown={(e)=>clickDown(e, ref2)}
        onMouseDown={(e)=>clickDown(e, ref2)}
        onPointerUp={(e)=>clickUp(e, ref2)}
        onMouseUp={(e)=>clickUp(e, ref2)}
        onTouchEnd={(e)=>clickUp(e, ref2)}
        onPointerOut={(e)=>clickUp(e, ref2)}
        >
        <audio ref={ref2} loop >
          <source  src="/audio/clip2.mp3" type="audio/mpeg" />
        </audio>
      </div>

      <div className="gridcell"
        onPointerDown={(e)=>clickDown(e, ref3)}
        onMouseDown={(e)=>clickDown(e, ref3)}
        onPointerUp={(e)=>clickUp(e, ref3)}
        onTouchEnd={(e)=>clickUp(e, ref3)}
        onMouseUp={(e)=>clickUp(e, ref3)}
        onPointerOut={(e)=>clickUp(e, ref3)}
        >
        <audio ref={ref3} loop >
          <source  src="/audio/clip3.mp3" type="audio/mpeg" />
        </audio>
      </div>

      <div className="gridcell"
        onPointerDown={(e)=> clickDown(e, ref4)}
        onMouseDown={(e)=>clickDown(e, ref4)}
        onMouseUp={(e)=>clickUp(e, ref4)}
        onPointerUp={(e)=>clickUp(e, ref4)}
        onTouchEnd={(e)=>clickUp(e, ref4)}
        onPointerOut={(e)=>clickUp(e, ref4)}
        >
        <audio ref={ref4} loop >
          <source  src="/audio/clip4.mp3" type="audio/mpeg" />
        </audio>
      </div>

      <div className="gridcell"
        onPointerDown={(e)=> clickDown(e, ref5)}
        onMouseDown={(e)=>clickDown(e, ref5)}
        onMouseUp={(e)=>clickUp(e, ref5)}
        onPointerUp={(e)=>clickUp(e, ref5)}
        onTouchEnd={(e)=>clickUp(e, ref5)}
        onPointerOut={(e)=>clickUp(e, ref5)}
        >
        <audio ref={ref5} loop >
          <source  src="/audio/clip5.mp3" type="audio/mpeg" />
        </audio>
      </div>

      <div className="gridcell"
        onPointerDown={(e)=> clickDown(e, ref6)}
        onMouseDown={(e)=>clickDown(e, ref6)}
        onMouseUp={(e)=>clickUp(e, ref6)}
        onPointerUp={(e)=>clickUp(e, ref6)}
        onTouchEnd={(e)=>clickUp(e, ref6)}
        onPointerOut={(e)=>clickUp(e, ref6)}
        >
        <audio ref={ref6} loop >
          <source  src="/audio/clip6.mp3" type="audio/mpeg" />
        </audio>
      </div>


    </div>
  )
}
